import { Theme } from "@mui/material/styles/createTheme";
import { makeStyles } from "@mui/styles";

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);

const setBRadius = lightThemeColor?.borderRadius || "4px";

const setButtonBRadius = lightThemeColor?.IconButtonBorderRadius || "4px";

const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const orderListButtonBRadius =
  lightThemeColor?.orderListProp?.buttonRadius || "4px";
const orderListButtoCardBRadius =
  lightThemeColor?.orderListProp?.cardBorderRadius || "none";
const orderListHeadingFontSize =
  lightThemeColor?.orderListProp?.headingFontSize || "21px";

export const useStyles = makeStyles((theme: Theme) => ({
  topbar: {
    top: 0,
    zIndex: 1005,
    // transition: 'all 0.3s ease-in-out',
    height: "100px",
    backgroundColor: theme.palette.topbarButton.topbarBg,
    // paddingLeft: "75px",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
    },
    margin: "0px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: 15,
    padding: 0,
  },
  mobileTopbar: {
    top: 0,
    zIndex: 1005,
    // transition: 'all 0.3s ease-in-out',
    height: "100px",
    backgroundColor: theme.palette.cardAdd.default,
    margin: "0px",
  },
  topbarButton: {
    border: "none",
    borderRadius: "50%",
    backgroundColor: "transparent",
    transition: "all 0.3s ease-in-out",
    color: theme.palette.topbarButton.topbarItemColor,
    // padding: "0.5rem 0.5rem",
    position: "relative",
    "&.show, &.active, &:active, &:hover": {
      color: "#ff6c2f",
    },
  },
  topbarIcon: {
    width: "2rem",
    height: "2rem",
    borderRadius: "50%",
  },
  topbarImgButton: {
    border: "none",
    borderRadius: "50%",
    backgroundColor: "transparent",
    transition: "all 0.3s ease-in-out",
    color: theme.palette.topbarButton.topbarItemColor,
    padding: "0.5rem 0.5rem",
    position: "relative",
    "&.show, &.active, &:active, &:hover": {
      color: "#ff6c2f",
    },
  },
  topbarImgIcon: {
    width: "2rem",
    height: "2rem",
    borderRadius: "50%",
  },
  topbarIconProfile: {
    width: "2rem",
    height: "2rem",
    borderRadius: "50%",
  },
  topbarIconProfileImg: {
    width: "2.5rem",
    height: "2.5rem",
    borderRadius: "50%",
  },
  topbarTittle: {
    color: "#5d7186",
    height: "1.7rem",
    borderRadius: "50%",
  },
  appSearch: {
    position: "relative",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  formControl: {
    border: "none",
    paddingLeft: "40px",
    paddingRight: "15px",
    backgroundColor: theme.palette.topbarButton.topbarSearchBg,
    boxShadow: "none",
    height: "42px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  formControlList: {
    border: "none",
    paddingLeft: "40px",
    paddingRight: "15px",
    // borderRadius: "15%",
    // backgroundColor: theme.palette.topbarButton.topbarSearchBg,
    boxShadow: "none",
    height: "34px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
    // [theme.breakpoints.down("sm")]: {
    //   display: "none",
    // },
  },

  formControlListStatus: {
    border: "none",
    // paddingLeft: "40px",
    // paddingRight: "15px",
    boxShadow: "none",
    borderRadius: "4px",
    color: theme.palette.primary.main,
    height: "34px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
    // [theme.breakpoints.down("sm")]: {
    //   display: "none",
    // },
  },

  datePickerProper: {
    fontSize: 14,
    color: "#97c3df",
    backgroundColor: theme.palette.cardAdd.secBackColor,
  },

  formControlListPayment: {
    border: "none",
    paddingLeft: "5px",
    paddingRight: "15px",
    backgroundColor: theme.palette.topbarButton.topbarSearchBg,
    boxShadow: "none",
    height: "34px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
  },

  searchWidgetIcon: {
    position: "absolute",
    zIndex: 10,
    fontSize: "25px",
    left: "11px",
    top: "50%",
    color: theme.palette.primary.main,
    transform: "translateY(-50%)",
    cursor: "pointer",
  },
  searchWidgetIcon23: {
    position: "absolute",
    zIndex: 10,
    fontSize: "25px",
    left: "11px",
    top: "50%",
    color: theme.palette.primary.main,
    transform: "translateY(-50%)",
    cursor: "pointer",
  },
  searchTextField: {
    width: "100%",
    backgroundColor: "#f9fbff",
    // backgroundColor: theme.palette.cardAdd.secBackColor,
    borderRadius: setBRadius,
    "& .MuiOutlinedInput-root": {
      borderRadius: setBRadius,
      // backgroundColor: "#f9fbff",
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.cardAdd.secBackColor,
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
  },
  searchTextField34: {
    width: "100%",
    backgroundColor: "#d0eafa",
    // backgroundColor: theme.palette.cardAdd.secBackColor,
    borderRadius: setBRadius,
    "& .MuiOutlinedInput-root": {
      borderRadius: setBRadius,
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.cardAdd.secBackColor,
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
  },

  searchTextField2: {
    width: "100%",
    backgroundColor: "white",
    // backgroundColor: theme.palette.cardAdd.secBackColor,
    borderRadius: setBRadius,
    "& .MuiOutlinedInput-root": {
      borderRadius: setBRadius,
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.cardAdd.secBackColor,
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
  },
  searchWidgetIconEdit: {
    position: "absolute",
    zIndex: 10,
    fontSize: "18px",
    left: "11px",
    top: "50%",
    color: "#8486a7",
    transform: "translateY(-50%)",
    cursor: "pointer",
    paddingRight: "2px",
  },
  searchWidgetIconClose: {
    right: "7px",
    left: "auto !important",
  },
  notchedOutline: {
    border: "none",
  },
  drawerHeader: {
    height: "100px",
    backgroundColor: theme.palette.topbarButton.drawerHeader,
    paddingLeft: "75px",
    margin: "0px",
  },

  h1: {
    fontSize: "calc(1.35rem + 1.2vw)",
    fontWeight: 600,
    lineHeight: 1.1,
    color: theme.palette.heading.headingColor,
    "@media (min-width: 1200px)": {
      fontSize: "2.25rem",
    },
  },
  dashboardTypograpy: {
    textTransform: "uppercase",
    color: "#a7a7a7",
    fontWeight: 550,
    lineHeight: 1.1,
    fontSize: "16px",
  },
  dashboardTypograpy2: {
    fontWeight: 550,
    fontSize: "17px",
  },
  dashboardTypograpy23: {
    fontSize: "15px",
  },
  tooltipTypograpy: {
    color: theme.palette.text.primary,
  },
  h2: {
    fontSize: "calc(1.3125rem + 0.75vw)",
    fontWeight: 600,
    lineHeight: 1.1,
    color: theme.palette.heading.headingColor,
    "@media (min-width: 1200px)": {
      fontSize: "1.875rem",
    },
  },
  h3: {
    fontSize: "calc(1.2rem + 0.3vw)",
    fontWeight: 600,
    lineHeight: 1.1,
    color: theme.palette.heading.headingColor,
    "@media (min-width: 1200px)": {
      fontSize: "1.5rem",
    },
  },
  h3Heading: {
    fontWeight: 600,
    lineHeight: 1.1,
    color: "#313b5e",
    fontSize: "20px",
  },
  h4: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.heading.headingColor,
    // textTransform: "uppercase",
  },
  PaymentTypograpy: {
    fontSize: "1.125rem",
    fontWeight: 500,
    lineHeight: "21px",
    color: theme.palette.heading.headingColor,
    textTransform: "uppercase",
  },
  h4Text: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.heading.headingColor,
    textTransform: "uppercase",
  },
  h4TextTopBar: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.topbarButton.topBarHeading,
    textTransform: "uppercase",
  },
  h4Text2: {
    fontSize: "1.3rem",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.primary.main,
    textTransform: "uppercase",
  },

  h4Text24: {
    fontSize: "1.1rem",
    fontWeight: 400,
    // lineHeight: "21px",
    color: "white",
    // textTransform: "uppercase",
  },
  h5: {
    fontSize: "0.9375rem",
    fontWeight: 600,
    lineHeight: 1.1,
    color: theme.palette.heading.headingColor,
  },
  h6: {
    fontSize: "0.75rem",
    fontWeight: 600,
    lineHeight: 1.1,
    color: theme.palette.heading.headingColor,
  },
  menuTitle: {
    cursor: "default",
    fontSize: "13px",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    color: theme.palette.topbarButton.drawerHeadingText,
    opacity: 0.6,
    fontWeight: 600,
    padding: `${theme.spacing(1)} ${theme.spacing(1.25)}`,
    transition: "all 0.3s ease-in-out",
    height: "36px",
    margin: 0,
  },
  menuTitle2: {
    cursor: "default",
    fontSize: "13px",
    letterSpacing: "0.05em",
    color: theme.palette.primary.main,
    fontWeight: 600,
    padding: `${theme.spacing(1)} ${theme.spacing(1.25)}`,
    transition: "all 0.3s ease-in-out",
    height: "36px",
    margin: 0,
  },
  listItemIcomMainMenu: {
    margin: 0,
    width: 40,
    marginLeft: 0,
    color: theme.palette.text.primary,
    opacity: 0.6,
  },

  body1: {
    fontSize: "1rem",
    lineHeight: 1.5,
    // marginBottom: "1rem",
    textAlign: "center",
    margin: 0,
    textTransform: "uppercase",
  },
  bodyDialog: {
    fontSize: "1rem",
    lineHeight: 1.5,
    // marginBottom: "1rem",
    textAlign: "center",
    margin: 0,
    // textTransform: "uppercase",
  },
  bodyDialog23: {
    fontSize: "1rem",
    lineHeight: 1.5,
    // marginBottom: "1rem",
    margin: 0,
    // textTransform: "uppercase",
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: 1.13,
    marginBottom: "1rem",
  },
  subtitle1: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.57,
    marginBottom: "0.5rem",
  },
  subtitle2: {
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: 1.57,
    marginBottom: "0.5rem",
  },
  button: {
    fontSize: "0.875rem",
    fontWeight: 700,
    textTransform: "uppercase",
  },
  caption: {
    fontSize: "0.75rem",
    lineHeight: 1.66,
  },
  overline: {
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: 2.66,
    textTransform: "uppercase",
  },

  navbarHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "0 auto",
  },

  searchIcon: {
    position: "absolute",
    zIndex: 10,
    fontSize: 18,
    left: 11,
    top: "50%",
    color: "#8486a7",
    transform: "translateY(-50%)",
    cursor: "pointer",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    paddingRight: theme.spacing(1),
    backgroundColor: "var(--bs-topbar-search-bg)",
    border: "none",
    boxShadow: "none",
    height: 42,
    width: "100%",
  },
  buttonToggleMenu: {
    color: "var(--bs-topbar-item-color)",
    backgroundColor: "transparent",
    borderRadius: 0,
    "&:hover": {
      color: "#ff6c2f",
    },
  },
  topbarItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "var(--bs-topbar-height)",
  },
  card: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderRadius: setCardBRadius,
    boxShadow: "none",
  },
  cardPrimary: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
    overflow: "hidden",
  },
  cardDanger: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid ${theme.palette.error.main}`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
    overflow: "hidden",
  },
  cardOrangeee: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid #e3791a`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
    overflow: "hidden",
  },
  dashboardDangerTypograpy: {
    textTransform: "uppercase",
    color: theme.palette.error.main,
    fontWeight: 550,
    lineHeight: 1.1,
    fontSize: "16px",
  },
  dashboardOrrangeTypograpy: {
    textTransform: "uppercase",
    color: "#e3791a",
    fontWeight: 550,
    lineHeight: 1.1,
    fontSize: "16px",
  },
  dashboardDanger: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#d32f2f",
    backgroundColor: "#fdecea",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardOrange: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#e3791a",
    backgroundColor: "#fff1cd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  cardItemViewSuccess: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `3px solid ${theme.palette.success.main}`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
    overflow: "hidden",
  },

  cardItemViewError: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `3px solid ${theme.palette.error.main}`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
    overflow: "hidden",
  },

  cardGreen: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid #007f00`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
    overflow: "hidden",
  },
  cardGreen24: {
    backgroundColor: "#f4fffa",
    p: "24px",
    borderBottom: `5px solid #007f00`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardGreenBAckGroundColor: {
    backgroundColor: theme.palette.cardAdd.secBackColor,
    p: "24px",
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardGreenBAckGroundColorMobile: {
    backgroundColor: theme.palette.cardAdd.secBackColor,
    // p: "24px",
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardGreenBAckGroundColor12: {
    backgroundColor: "#fff7f1",
    p: "24px",
    borderBottom: `5px solid #df6800`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardGreenTypograpy: {
    color: "#274057",
    fontSize: "15px",
  },
  cardRed: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid #d30000`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
  },
  cardRed2: {
    backgroundColor: "#fff2f2",
    p: "24px",
    borderBottom: `5px solid #d73a3c`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardRed212: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid #d73a3c`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardRed23: {
    backgroundColor: "#fff2f2",
    p: "24px",
    borderBottom: `5px solid #d30000`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardYellow: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid #e1c300`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardYellow23: {
    backgroundColor: "#fcfbf0",
    p: "24px",
    borderBottom: `5px solid #e1c300`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardOrrange: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid #df6800`,
    borderRadius: "none",
    boxShadow: "none",
  },
  cardBlue: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid #0f5fc2`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
  },
  cardPurple: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid #5932ea`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
  },
  cardGreen2: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    p: "24px",
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    borderRadius: setCardBRadius,
    boxShadow: "none",
  },
  Dialog: {
    backgroundColor: theme.palette.background.default,
    borderRadius: setBRadius,
    padding: "24px",
  },
  DialogMobile: {
    backgroundColor: theme.palette.background.default,
    borderRadius: setBRadius,
    padding: "10px",
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    color: theme.palette.cardAdd.headingColor,
    textTransform: "capitalize",
    // color: "#bdbec7",
  },
  cardTitless: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    color: theme.palette.cardAdd.headingColor,
    // textTransform: "capitalize",
    // color: "#bdbec7",
  },
  cardTitleTab: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    color: theme.palette.cardAdd.headingColor,
    // textTransform: "uppercase",
    // color: "#bdbec7",
  },
  cardTitle2: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    textTransform: "uppercase",
    // color: "#bdbec7",
  },
  cardTitle256: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    // textTransform: "uppercase",
    // color: "#bdbec7",
  },
  ActivityHistoryHEading: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    // color: theme.palette.cardAdd.headingColor,
    // textTransform: "uppercase",
    color: theme.palette.primary.main,
  },
  ActivityHistoryHEading2: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    // color: theme.palette.cardAdd.headingColor,
    // textTransform: "uppercase",
    color: "#6e94a9",
  },
  ActivityHistoryHEading23: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    // color: theme.palette.cardAdd.headingColor,
    // textTransform: "uppercase",
    color: theme.palette.primary.main,
  },
  cardTitleContainer: {
    borderBottom: 1,
    padding: 2,
    backgroundColor: theme.palette.cardAdd.bgColor,
  },
  stepperCard: {
    boxShadow: "none",
    backgroundColor: theme.palette.cardAdd.bgColor,
    borderRadius: setCardBRadius,
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
  },
  stepperCardProductView: {
    boxShadow: "none",
    backgroundColor: theme.palette.cardAdd.bgColor,
    borderRadius: setCardBRadius,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
  },
  compactStatusCard: {
    borderRadius: setCardBRadius,
    padding: 2,
    height: "100%",
    display: "flex",
    alignItems: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  },

  stepperCard3: {
    boxShadow: "none",
    backgroundColor: "#c8f7a1",
    borderRadius: "none",
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
    minHeight: "100vh",
  },

  stepperCard4: {
    boxShadow: "none",
    backgroundColor: "#254506",
    // backgroundColor: "#1e1e1e",
    borderRadius: "none",
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
    minHeight: "100vh",
  },
  stepperCard5: {
    boxShadow: "none",
    backgroundColor: "#f7ffef",
    // backgroundColor: "#1e1e1e",
    borderRadius: "none",
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
    minHeight: "100vh",
  },
  stepperCard2: {
    boxShadow: "none",
    backgroundColor: theme.palette.cardAdd.bgColor,
    borderRadius: "20px",
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
  },
  stepperCardGrid: {
    boxShadow: "none",
    borderRadius: "8px",
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
    display: "flex",
    flexDirection: "column",
  },
  addButtonList: {
    borderBottom: 1,
    padding: 2,
    backgroundColor: theme.palette.cardAdd.bgColor,
  },

  addButtonList1: {
    borderBottom: 1,
    padding: 2,
    backgroundColor: theme.palette.cardAdd.bgColor,
    textTransform: "uppercase",
    width: "100%",
  },
  addButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    // backgroundColor: "#ff6c2f",
    borderRadius: setBRadius,
    // boxShadow: "0px 2px 6px 0px",
    // color: '#aab8c5',
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  addButton2: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    height: "45px",
    // backgroundColor: "#ff6c2f",
    // borderRadius: "15px",
    // boxShadow: "0px 2px 6px 0px",
    // color: '#aab8c5',
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  addButton1: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: "uppercase",
    width: "100%",
    height: "45px",
    // backgroundColor: "#ff6c2f",
    // borderRadius: "15px",
    // boxShadow: "0px 2px 6px 0px",
    // color: '#aab8c5',
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  actionButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    minWidth: "150px",
    backgroundColor: theme.palette.cardAdd.secBackColor,
    borderRadius: setBRadius,
    // boxShadow: "0px 2px 6px 0px",
    color: "#99bcd1",
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  actionButtonTwo: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    minWidth: "150px",
    minHeight: "40px",
    backgroundColor: "#4eccc5",
    borderRadius: setBRadius,
    // boxShadow: "0px 2px 6px 0px",
    color: "white",
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  addButtonPdfExcel: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setBRadius,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.cardAdd.secBackColor,
    minWidth: "75px",
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  textField: {
    flexGrow: 1,
    width: "100%",
    fontSize: 14,
  },
  textField2: {
    flexGrow: 1,
    width: "100%",
    fontSize: "1.1rem",
    fontWeight: 400,
    lineHeight: "21px",
    color: "white",
  },
  textFieldQuote2: {
    flexGrow: 1,
    width: "100%",
    fontSize: "1.1rem",
    fontWeight: 400,
    lineHeight: "21px",
    color: "white",
    // borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
  },
  textField200: {
    flexGrow: 1,
    width: "100%",
    fontSize: 14,
    minWidth: "100px",
  },
  gridBordrBottomColor: {
    borderBottom: 1,
    padding: 2,
    borderColor: theme.palette.divider,
  },
  table: {
    width: "100%",
    marginBottom: "1.5rem",
    verticalAlign: "top",
    // borderColor: `1px solid ${theme.palette.cardAdd.borderColor}`,
    "& > :not(caption) > * > *": {
      padding: "0.85rem 0.85rem",
    },
  },

  tableHeaderRow: {
    textTransform: "uppercase",
    color: "#e0e1e5",
    // background: theme.palette.cardAdd.rowHeaderColor,
    // borderRight: `1px solid ${theme.palette.cardAdd.borderColor}`,
    // borderLeft: `1px solid ${theme.palette.cardAdd.borderColor}`,
  },

  tablCell1: {
    border: `1px solid #af9a8e`,
    borderRadius: "8px",
  },

  tablCell12: {
    borderBottom: `1px solid #af9a8e`,
  },

  tablCellpx: {
    borderBottom: `2px solid ${theme.palette.cardAdd.borderColor}`,
  },

  tablheader: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    color: theme.palette.cardAdd.headingColor,
    minWidth: "200px",
  },
  tablCell: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "100px",
  },
  tablheaderPayroll: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    color: theme.palette.cardAdd.headingColor,
    minWidth: "100px",
  },
  tablCellPayroll: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "100px",
  },
  tablheaderId: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    color: theme.palette.cardAdd.headingColor,
  },
  tablCellId: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
  },
  primaryHeading: {
    color: theme.palette.primary.main,
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: "15px",
  },
  primaryHeading12: {
    color: "#fef3c7",
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: "15px",
  },
  tablheaderCreate: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    color: "#e0e1e5",
  },
  tablheaderCreate160: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    maxWidth: "160px",
    color: "#e0e1e5",
  },

  tableRowHover: {
    "&:hover": {
      backgroundColor: theme.palette.cardAdd.tablehover,
      "& td, & th": {
        // border: `1px solid ${theme.palette.cardAdd.borderColor}`,
      },
    },
    "& td, & th": {
      // border: `1px solid ${theme.palette.cardAdd.borderColor}`,
    },
  },

  editButton: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setButtonBRadius,
    opacity: 0.65,
    color: "white",
    border: "none",
    padding: 1,
    minWidth: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.cardAdd.secBackColor,
      "& .MuiSvgIcon-root": {
        color: "black",
      },
    },
  },

  deleteButton: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setButtonBRadius,
    opacity: 0.65,
    color: "#ef5f5f",
    border: "none",
    padding: 1,
    minWidth: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#ef5f5f54",
    "&:hover": {
      backgroundColor: "#ef5f5f",
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
  },
  viewButton: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setButtonBRadius,
    opacity: 0.65,
    color: "#323a46",
    // color: "#eef2f7",
    border: "none",
    padding: 1,
    minWidth: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#99c9cf6e",
    "&:hover": {
      backgroundColor: "#323a46",
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
  },
  editButtonTenantList: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setButtonBRadius,
    opacity: 0.65,
    color: "white",
    border: "none",
    padding: 1,
    minWidth: 44,
    height: 33,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
    boxShadow: "none",
  },
  editButtonList: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setButtonBRadius,
    color: "white",
    border: "none",
    padding: 1,
    minWidth: 44,
    height: 33,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.iconButton.editButtonColor,
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
    boxShadow: "none",
  },
  editListIconAdded: {
    fontSize: "21px",
    color: theme.palette.iconButton.editIconColor,
  },
  deleteButtonList: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setButtonBRadius,
    color: "white",
    border: "none",
    padding: 1,
    minWidth: 44,
    height: 33,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.iconButton.deleteButtonColor,
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
    boxShadow: "none",
  },
  viewButtonList: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setButtonBRadius,
    color: "white",
    border: "none",
    padding: 1,
    minWidth: 44,
    height: 33,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.iconButton.viewButtonColor,
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
    boxShadow: "none",
  },
  editListIcon: {
    fontSize: "21px",
    color: theme.palette.iconButton.editIconColor,
  },
  editListIconG: {
    fontSize: "21px",
    color: theme.palette.iconButton.editIconColor,
  },
  deleteListIcon: {
    fontSize: "21px",
    color: theme.palette.iconButton.deleteIconColor,
  },
  viewListIcon: {
    fontSize: "21px",
    color: theme.palette.iconButton.viewIconColor,
  },
  imgBox: {
    border: "2px dashed",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "6px",
    cursor: "pointer",
    minHeight: "150px",
    padding: "20px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  imgBox2: {
    borderRadius: "6px",
    cursor: "pointer",
    minHeight: "150px",
    padding: "20px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  SelectImageBox: {
    width: "100%",
    height: "auto",
    maxWidth: "100px",
    maxHeight: "100px",
    marginRight: "auto",
    objectFit: "cover",
  },
  titleGrid: {
    borderColor: theme.palette.cardAdd.borderColor,
  },
  activityHistoryHeaderGrid: {
    borderColor: theme.palette.cardAdd.borderColor,
    // backgroundColor: theme.palette.cardAdd.secBackColor,
  },
  titleGridBottomBoredr: {
    borderBottom: `3px solid ${theme.palette.cardAdd.borderColor}`,
  },
  backgroundColorView: {
    backgroundColor: "#f9f9f9",
    borderLeft: `5px solid #007f00`,
  },
  backgroundColorView2: {
    backgroundColor: "#f9f9f9",
  },
  printerBox: {
    border: "2px dashed",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "6px",
    minHeight: "150px",
    padding: "5px",
  },
  colorBox: {
    border: "2px solid",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "6px",
    minHeight: "70px",
    padding: "20px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  barCodeBox: {
    border: "2px solid",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "6px",
    minHeight: "70px",
    padding: "20px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  discriptionTextField: {
    flexGrow: 1,
    width: "100%",
    fontSize: 14,
    // backgroundColor: theme.palette.cardAdd.textDescription,
  },
  customerDetails: {
    fontWeight: 800,
    color: "#5a5a5a",
  },
  staffTypograpy: {
    color: theme.palette.primary.main,
  },
  customerDiscription: {
    backgroundColor: theme.palette.cardAdd.textDescription,
  },
  productBox: {
    border: "2px solid",
    borderColor: theme.palette.cardAdd.borderColor,
    [theme.breakpoints.down("md")]: {
      height: "200px",
    },
    borderRadius: "6px",
    height: "350px",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  productViewPageTableHeaderCell: {
    fontSize: "16px",
    fontWeight: 600,
    borderBottom: 4,
    borderColor: theme.palette.cardAdd.borderColor,
  },
  productBarCodeBox: {
    border: "2px solid",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "6px",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  nameTableList: {
    // color: theme.palette.table.nameHeadingColor,
    fontSize: "15px",
    fontWeight: 500,
  },
  SelectImageTable: {
    width: "40px",
    height: "40px",
    border: "none",
    position: "inherit",
  },
  SelectImageTable3d: {
    width: "45px",
    height: "45px",
    border: "none",
    borderRadius: 8,
    position: "inherit",
  },
  SelectImageTable70: {
    width: "70px",
    height: "70px",
    border: "none",
    position: "inherit",
  },
  SelectImageTableTwo: {
    width: "120px",
    height: "120px",
    border: "none",
    position: "inherit",
  },
  SelectImageTableList: {
    width: "54px",
    height: "54px",
    border: "none",
    position: "inherit",
  },
  SelectImageTableBox: {
    width: "56px",
    height: "56px",
    p: "5px",
    // border: "1px solid",
    // borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  SelectImageTableBoxBorder: {
    width: "56px",
    height: "56px",
    p: "5px",
    border: "1px solid",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  SelectImageTableBoxBorder23: {
    width: "56px",
    height: "56px",
    p: "1px",
    border: "1px solid",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  SelectImageTableBoxList: {
    width: "60px",
    height: "60px",
    p: "5px",
    // border: "1px solid",
    // borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  suiteBox: {
    margin: theme.spacing(1),
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    border: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderRadius: "8px",
    width: "120px",
    height: "60px",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    transition: "background-color 0.3s, box-shadow 0.3s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      boxShadow: theme.shadows[3],
    },
  },
  suiteBoxBorderNone: {
    margin: theme.spacing(1),
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    borderRadius: "8px",
    width: "50px",
    height: "50px",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    transition: "background-color 0.3s, box-shadow 0.3s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      boxShadow: theme.shadows[3],
    },
  },
  textFieldQuote: {
    flexGrow: 1,
    width: "100%",
    fontSize: 14,
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
  },
  textFieldQuote23: {
    flexGrow: 1,
    width: "100%",
    fontSize: 14,
  },
  textFieldQuoteNoBorder: {
    flexGrow: 1,
    width: "100%",
    fontSize: 14,
  },
  textFieldQuoteRigt: {
    flexGrow: 1,
    width: "100%",
    fontSize: 14,
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
  },
  profileBottomSetUp: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "300px",
    background: `linear-gradient(to bottom, ${theme.palette.primary.main} 35%, #FFFFFF 15%, #FFFFFF 50%)`,
  },
  profileBottomSetUpSmall: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "260px",
    background: `linear-gradient(to bottom, #FFFFFF 42%, #FFFFFF 18%, #FFFFFF 50%)`,
  },

  profileBottomSetUpSmall2: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    height: "50px",
    p: 5,
    background: `linear-gradient(to bottom, #FFFFFF 42%, #FFFFFF 18%, #FFFFFF 50%)`,
  },

  buttonGroupList: {
    display: "flex",
    justifyContent: "center",
    // gap: '10px',
    // marginTop: '16px',
  },

  profileDetailItemList: {
    marginBottom: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  contactInfoProfile: {
    display: "flex",
    alignItems: "left",
    justifyContent: "left",
    background: theme.palette.primary.main,
    borderRadius: setCardBRadius,
    color: "white",
    fontSize: "15px",
    padding: "2px 10px",
  },
  contactInfoProfile2: {
    display: "flex",
    alignItems: "left",
    justifyContent: "left",
    background: theme.palette.primary.main,
    borderRadius: "4px",
    color: "white",
    padding: "2px 10px",
    textTransform: "uppercase",
    fontSize: "21px",
    fontWeight: 400,
  },

  buttonItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  profileImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  },
  profileDetails: {
    color: theme.palette.text.secondary,
    textAlign: "center",
    marginTop: "10px",
  },
  ActivityHistoryDtails: {
    color: theme.palette.text.secondary,
    textAlign: "center",
    padding: 15,
  },
  profileDetailItem: {
    marginBottom: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    color: theme.palette.cardAdd.headingColor,
    fontWeight: 600,
  },
  contactInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
  },
  iconText: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "16px",
  },
  buttonLabel: {
    marginTop: "8px",
  },
  buttonLabelForHeading: {
    marginTop: "2px",
    fontSize: "21px",
  },
  editButtonProfile: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: "50%",
    color: theme.palette.primary.main,
    border: "none",
    padding: 5,
    minWidth: 50,
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.cardAdd.secBackColor,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
    "&:active": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
  },
  editButtonProfileBack: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: "50%",
    color: "#ff5b5b",
    border: "none",
    padding: 5,
    minWidth: 50,
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ffe6e6",
    "&:hover": {
      backgroundColor: "#ffe6e6",
      "& .MuiSvgIcon-root": {
        color: "#6b3333",
      },
    },
    "&:active": {
      backgroundColor: "#ffe6e6",
      "& .MuiSvgIcon-root": {
        color: "#6b3333",
      },
    },
  },
  editButtonProfileBack2: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "30px",
    fontWeight: 600,
    lineHeight: 1.5,
    borderRadius: "50%",
    color: "#747474",
    border: "none",
    padding: 5,
    minWidth: 60,
    height: 60,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#eee",
    "&:hover": {
      backgroundColor: "#eee",
      "& .MuiSvgIcon-root": {
        color: "#747474",
      },
    },
    "&:active": {
      backgroundColor: "#eee",
      "& .MuiSvgIcon-root": {
        color: "#747474",
      },
    },
  },
  editButtonProfileBox: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 60,
    height: 60,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#ff6c2f",
    backgroundColor: "#fff0ea",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "0.75rem",
  },
  dashboardPrimary: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.default,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },

  dashboardGreen: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#007f00",
    backgroundColor: "#cdffcd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardGreenWithoutBackColor: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#007f00",
    // backgroundColor: "#cdffcd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardGreenWithoutBackColor2: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#007f00",
    // backgroundColor: "#cdffcd",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderRadius: "50%",
  },
  dashboardGreenWithoutBackColor23: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 40,
    height: 40,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "white",
    backgroundColor: "#007f00",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderRadius: "50%",
  },
  dashboard234: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 40,
    height: 40,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "white",
    backgroundColor: "#d30000",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderRadius: "50%",
  },
  dashboard2345: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 40,
    height: 40,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "white",
    backgroundColor: "#e1c300",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderRadius: "50%",
  },
  dashboardOrangeWithoutBackColor: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#df6800",
    // backgroundColor: "#cdffcd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardLightBlueWithoutBackColor: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#4eccc5",
    // backgroundColor: "#cdffcd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardGreen2: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "white",
    backgroundColor: "#66b266",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardRed2: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "white",
    backgroundColor: "#e56666",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardGree2: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "white",
    backgroundColor: "#7ad9d3",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardRed: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#d93a3b",
    backgroundColor: "#ffe0e0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardRedWithoutBackColor: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#d93a3b",
    // backgroundColor: "#ffe0e0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardYellow: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#e1c300",
    // backgroundColor: "#ffe0e0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardBlue: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "white",
    backgroundColor: "#578fd4",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardPurpele: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "white",
    backgroundColor: "#957ff2",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardPurpeleWithoutBackColor: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#5932ea",
    // backgroundColor: "#957ff2",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  dashboardBlueWithoutBackColor: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 70,
    height: 70,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#0f5fc2",
    // backgroundColor: "#957ff2",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  editButtonStatusPaid: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 100,
    height: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#22c55e",
    backgroundColor: "#d3f3df",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },
  editButtonStatusPaidSedul: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 100,
    height: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#22c55e",
    backgroundColor: "#d3f3df",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
    textAlign: "center",
  },
  editButtonStatusPunchIn: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 100,
    // maxWidth: 100,
    // width: "100%",
    height: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#ff753f",
    backgroundColor: "#ffe2d5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },
  editButtonStatusPaidPunchDate: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 150,
    height: "100%",
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    padding: "5px",
    px: "6px",
    py: "12px",
    color: "#22c55e",
    backgroundColor: "#d3f3df",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
    textAlign: "center",
  },
  editButtonStatusPending: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 100,
    // maxWidth: 100,
    // width: "100%",
    height: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#ef5f5f",
    backgroundColor: "#fcdfdf",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  editButtonStatusBooked: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 100,
    // maxWidth: 100,
    // width: "100%",
    height: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#db2a2a",
    backgroundColor: "#ffe0e0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },
  editButtonStatusAvailable: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 100,
    // maxWidth: 100,
    // width: "100%",
    height: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#007f00",
    backgroundColor: "#cdffcd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  editButtonStatusAvailableView: {
    y: "0.5rem",
    fontSize: "0.875rem",
    // width: "100%",
    // maxWidth: 100,
    // width: "100%",
    minHeight: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#007f00",
    backgroundColor: "#cdffcd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "20px",
  },
  editButtonStatusAvailableView3: {
    y: "0.5rem",
    fontSize: "1rem",
    // width: "100%",
    // maxWidth: 100,
    // width: "100%",
    minHeight: 35,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "black",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "20px",
  },

  editButtonStatusAvailableView2: {
    y: "0.5rem",
    fontSize: "0.875rem",
    // width: "100%",
    // maxWidth: 100,
    // width: "100%",
    minHeight: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "white",
    backgroundColor: "#3f9b59",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "20px",
  },

  editButtonStatusAvailablenotwidth: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 80,
    // maxWidth: 100,
    // width: "100%",
    height: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#007f00",
    backgroundColor: "#cdffcd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  editButtonStatusWaiting: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 100,
    // maxWidth: 100,
    // width: "100%",
    height: 30,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "#e3791a",
    backgroundColor: "#fff1cd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },
  editButtonPayment: {
    y: "0.5rem",
    fontSize: "1.2rem",
    minWidth: 150,
    // maxWidth: 100,
    // width: "100%",
    minHeight: 40,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    px: "6px",
    py: "12px",
    color: "white",
    backgroundColor: "#4eccc5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  staffNameBox: {
    y: "0.5rem",
    fontSize: "12px",
    minHeight: 40,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    color: "white",
    backgroundColor: "#4182f9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "20px",
  },

  editButtonProfileBoxCursour: {
    y: "0.5rem",
    fontSize: "0.875rem",
    width: 60,
    height: 60,
    fontWeight: 400,
    lineHeight: 1.5,
    border: "none",
    padding: 1,
    color: "#ff6c2f",
    backgroundColor: "#ffccbc",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "0.75rem",
    cursor: "pointer",
  },
  profileBottomDwonProfile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    width: "240px",
    height: "100px",
    borderRadius: "8px",
    backgroundColor: "#000000",
    // border: `5px solid #FFFFFF`,
    overflow: "hidden",
    // marginTop: '-25px',
    zIndex: 1,
  },
  profileTypograpy: {
    fontSize: "45px",
    // color: "#FFFFFF",
    fontWeight: 600,
  },
  profileTypograpy2: {
    fontSize: "45px",
    // color: "#FFFFFF",
    fontWeight: 600,
  },
  showMoreLink: {
    color: "#1976d2",
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "none",
    },
  },
  tableHeaderCell: {
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
    // add any other styling you need here
  },
  profileBottomDwon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    border: `5px solid #FFFFFF`,
    overflow: "hidden",
    // marginTop: '-25px',
    zIndex: 1,
  },
  // availableBox: {
  //   backgroundColor: '#d3f3df',
  //   color: '#22c55e',
  //   fontSize: "14px",
  //   fontWeight: 600,
  //   height: "21px",
  //   px: "6px",
  //   py: "12px",
  //   textAlign: "center",
  //   borderRadius: "4px"
  // },

  availableBox: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    // backgroundColor: "#ff6c2f",
    borderRadius: 4,
    // boxShadow: "0px 2px 6px 0px",
    // color: '#aab8c5',
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  bookedBox: {
    backgroundColor: "#B0BEC5",
    color: "white",
    fontWeight: "bold",
    pointerEvents: "none",
  },

  cardTitleGrid: {
    // borderColor: appColor.greenSmoke[20],
  },

  cardTitleTypography: {
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    fontSize: "21px",
    // color: appColor.black,
  },

  typography: {
    fontWeight: 400,
    fontSize: 14,
  },

  searchButton: {
    // backgroundColor: appColor.blue[100],
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      // backgroundColor: appColor.blue[100],
      boxShadow: "none",
    },
    "&:active": {
      // backgroundColor: appColor.blue[100],
      boxShadow: "none",
    },
  },
  SelectImageTableBoxwithBorder: {
    width: "56px",
    height: "56px",
    p: "5px",
    // border: "1px solid",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  SelectImageTableBoxwithBorder2: {
    width: "100%",
    aspectRatio: "1 / 0.5",
    padding: "5px",
    backgroundColor: "#f5f5f56b",
    borderColor: "",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  SelectImageTableBoxwithBorder24: {
    width: "100%",
    aspectRatio: "1 / 0.5",
  },
  isLoading: {
    color: theme.palette.primary.main,
    // width: '12px',
    // height: '12px',
  },

  quotesCardInvoice: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    [theme.breakpoints.down("md")]: {
      marginLeft: "2px",
      marginRight: "2px",
    },
    marginLeft: "5px",
    marginRight: "5px",
    padding: "12px",
    borderRadius: "8px",
    boxShadow: "none",
  },

  quotesCardStaff: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    [theme.breakpoints.down("md")]: {
      marginLeft: "2px",
      marginRight: "2px",
    },
    marginLeft: "5px",
    marginRight: "5px",
    // padding: "24px",
    // borderRadius: "12px",
    boxShadow: "none",
  },
  ListPayroll: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    // border: `1px solid #c4c4c4`,
    width: "100%",
    borderRadius: setBRadius,
    // height: 70
    backgroundColor: theme.palette.cardAdd.secBackColor,
  },
  ListItemPayroll: {
    // borderLeft: `1px solid ${theme.palette.cardAdd.borderColor}`,
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    height: 32,
  },
  ListItemPayrollToday: {
    fontWeight: "normal",
    // minWidth: "32px",
    height: "32px",
    padding: "0",
    margin: 0,
    boxShadow: "none",
    // border: `1px solid ${theme.palette.cardAdd.borderColor}`,
    backgroundColor: theme.palette.cardAdd.secBackColor,
    color: theme.palette.primary.main,
    textTransform: "uppercase",
    // "&:hover": {
    //   backgroundColor: theme.palette.primary.dark,
    // },
  },
  quotesCard: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    [theme.breakpoints.down("md")]: {
      marginLeft: "2px",
      marginRight: "2px",
    },
    marginLeft: "5px",
    marginRight: "5px",
    padding: "24px",
    // borderRadius: "12px",
    boxShadow: "none",
    minHeight: "100vh",
  },

  quotesCard2: {
    backgroundColor: theme.palette.cardAdd.bgColor,
    [theme.breakpoints.down("md")]: {
      marginLeft: "2px",
      marginRight: "2px",
    },
    marginLeft: "5px",
    marginRight: "5px",
    padding: "24px",
    // borderRadius: "12px",
    boxShadow: "none",
  },
  OrderLisViewCard: {
    backgroundColor: "#1b344e",
    [theme.breakpoints.down("md")]: {
      marginLeft: "12px",
      marginRight: "12px",
    },
    marginLeft: "98px",
    marginRight: "98px",
    padding: "24px",
    // borderRadius: "12px",
    borderRadius: "none",
    boxShadow: "none",
    minHeight: "100vh",
  },
  h4Quoto: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.heading.headingColor,
  },
  h4QuotoTopBar: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.topbarButton.topBarHeading,
  },
  h4QuotoImg: {
    fontSize: "1.125rem",
    fontWeight: 400,
    lineHeight: "21px",
    color: theme.palette.topbarButton.drawerHeadingText,
  },
  titleGridInvoice: {
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "12px",
    // backgroundColor: "#dcf4f3",
    // padding: "2px"
  },
  invoiceImg: {
    width: "100%",
    height: "50px",
    padding: "12px",
    borderRadius: "12px",
    display: "block",
    cursor: "pointer",
  },
  bodyPrintHeading: {
    fontSize: "1rem",
    lineHeight: 1.5,
    // marginBottom: "1rem",
    color: "black",
    // fontWeight: "600px",
    fontWeight: 400,
    margin: 0,
    textTransform: "uppercase",
  },
  tablheader200: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "200px",
    color: "#e0e1e5",
  },
  tablheader150: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "150px",
    color: "#e0e1e5",
  },
  tablheader250: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "250px",
    color: "#e0e1e5",
  },
  tablheader50: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "50px",
    color: "#e0e1e5",
  },
  tablheader100: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "100px",
    color: "#e0e1e5",
  },
  tablheader300: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "300px",
    color: "#e0e1e5",
  },
  cardPaymenyt: {
    backgroundColor: "#ffe2d5",
    p: "24px",
    borderRadius: "8px",
    boxShadow: "none",
  },
  cardPaymenytSecound: {
    backgroundColor: "#dcf4f3",
    p: "24px",
    borderRadius: "8px",
    boxShadow: "none",
  },
  iconPaymenyt: {
    color: "#ff6c2f",
    fontSize: 60,
  },
  iconPaymenytSec: {
    color: "#346c6a",
    fontSize: 60,
  },
  statusCount: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "1rem",
    margin: "8px 0",
  },
  paymentRight: {
    borderRight: `3px solid ${theme.palette.cardAdd.borderColor}`,
  },
  paymentBox: {
    borderRight: `3px solid ${theme.palette.cardAdd.borderColor}`,
  },
  h3HeadingBox: {
    fontWeight: 700,
    lineHeight: "38.5px",
    color: "#313b5e",
    fontSize: "40px",
    pb: 1,
  },
  // cardTitleTypographPayment: {
  //   display: "flex",
  //   alignItems: "center",
  //   fontWeight: 500,
  //   fontSize: "18px",
  //   textTransform: "uppercase",
  // },
  cardTitleTypographPayment: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.heading.headingColor,
    textTransform: "uppercase",
  },
  h3HeadingBoxSec: {
    fontWeight: 400,
    lineHeight: "38.5px",
    color: "#313b5e",
    fontSize: "21px",
    pb: 1,
  },
  SelectImagInvoiceBox: {
    width: "80px",
    height: "80px",
    p: "5px",
    border: "1px solid",
    borderColor: theme.palette.cardAdd.borderColor,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  SelectImageInvoice: {
    width: "70px",
    height: "70px",
    border: "none",
    position: "inherit",
  },
  cardTitleTypographPaymentSec: {
    fontSize: "1.125rem",
    fontWeight: 700,
    lineHeight: "13px",
    color: theme.palette.heading.headingColor,
    textTransform: "uppercase",
  },
  dropdownPaper: {
    maxHeight: "200px",
    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
  },
  arrowIcon: {
    fontSize: "30px",
  },
  SelectImageTable12: {
    width: "90%",
    height: "90%",
    border: "none",
    position: "inherit",
  },
  SelectImageTableBoxwithBorder245: {
    width: "100%",
    aspectRatio: "1 /0.7",
    padding: "5px",
    // backgroundColor: "#f5f5f56b",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },

  SelectImageTableBoxwithBorder2456: {
    width: "100%",
    aspectRatio: "1 /0.7",
    padding: "5px",
    backgroundColor: "#f5f5f56b",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },

  requiedfield: {
    color: "red",
    // fontSize: "15px"
  },

  orderListLeftCard: {
    boxShadow: "none",
    backgroundColor: theme.palette.orderListProp.leftBgColor || "#776c7b",
    borderRadius: orderListButtoCardBRadius,
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
    minHeight: "109vh",
  },
  orderListLeftCardView: {
    backgroundColor: theme.palette.orderListProp.leftBgColor || "#776c7b",
    borderRadius: orderListButtoCardBRadius,
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
    minHeight: "109vh",
  },
  orderListLeftPaper: {
    backgroundColor: theme.palette.orderListProp.leftBgColor || "#776c7b",
    borderRadius: orderListButtoCardBRadius,
  },
  orderListLeftHeader: {
    borderColor: theme.palette.orderListProp.borderBgColor || "#e8f0f3",
    backgroundColor: theme.palette.orderListProp.leftTopBgColor || "#ffffff",
  },

  ordeListButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    backgroundColor: theme.palette.orderListProp.buttonBgColor || "#eaf3f2",
    borderRadius: orderListButtonBRadius,
    // boxShadow: "0px 2px 6px 0px",
    // color: '#aab8c5',
    color: theme.palette.orderListProp.buttonIconColor || "#599d95",
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },

  ordeListEditButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    backgroundColor: theme.palette.iconButton.editButtonColor,
    borderRadius: orderListButtonBRadius,
    // boxShadow: "0px 2px 6px 0px",
    // color: '#aab8c5',
    color: theme.palette.iconButton.editIconColor,
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
      backgroundColor: theme.palette.iconButton.editIconColor,
      color: theme.palette.iconButton.editButtonColor,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  ordeListConfirmButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    backgroundColor: theme.palette.orderListProp.payButtonColor,
    borderRadius: orderListButtonBRadius,
    // boxShadow: "0px 2px 6px 0px",
    // color: '#aab8c5',
    color: theme.palette.orderListProp.leftBgColor,
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
      backgroundColor: theme.palette.orderListProp.leftBgColor,
      color: theme.palette.orderListProp.payButtonColor,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  orderListTextField: {
    width: "100%",
    backgroundColor: "white",
    borderRadius: setBRadius,
    "& .MuiOutlinedInput-root": {
      borderRadius: orderListButtonBRadius,
      color: theme.palette.orderListProp.buttonIconColor || "#599d95",
      backgroundColor: theme.palette.orderListProp.buttonBgColor || "#eaf3f2",
      "& .MuiInputBase-input": {
        color: theme.palette.orderListProp.buttonIconColor || "#599d95",
      },
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
  },

  orderListSearchWidgetIcon: {
    position: "absolute",
    zIndex: 10,
    fontSize: "25px",
    left: "11px",
    top: "50%",
    color: theme.palette.orderListProp.buttonIconColor || "#599d95",
    transform: "translateY(-50%)",
    cursor: "pointer",
  },
  orderListRightCard: {
    boxShadow: "none",
    backgroundColor: theme.palette.orderListProp.rightBgColor || "#ffffff",
    borderRadius: orderListButtoCardBRadius,
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
    minHeight: "100vh",
  },
  orderListRightCard2: {
    boxShadow: "none",
    backgroundColor: theme.palette.orderListProp.rightBgColor || "#ffffff",
    borderRadius: orderListButtoCardBRadius,
    fontSize: "16px",
    p: 5,
    fontWeight: 400,
  },

  orderListRightHeader: {
    borderColor: theme.palette.cardAdd.borderColor,
    backgroundColor: theme.palette.orderListProp.leftTopBgColor || "#ffffff",
  },

  orderListRightHeader2: {
    borderColor: theme.palette.orderListProp.borderBgColor || "#e8f0f3",
  },

  orderListTabButtonSelect: {
    color: theme.palette.orderListProp.payButtonColor || "#298076",
    y: "0.5rem",
    fontSize: "15px",
    minHeight: 35,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "3px",
    py: "6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: orderListButtonBRadius,
  },
  orderListTabButton: {
    color: theme.palette.orderListProp.leftFontColor || "#85858f",
    y: "0.5rem",
    fontSize: "15px",
    minHeight: 35,
    fontWeight: 600,
    lineHeight: 1.5,
    border: "none",
    px: "3px",
    py: "6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: orderListButtonBRadius,
  },
  tabTypograpy: {
    fontSize: "15px",
    fontWeight: 600,
  },
  orderListProductCard: {
    boxShadow: "none",
    backgroundColor:
      theme.palette.orderListProp.productCardBgColor || "#eaf3f2",
    borderRadius: orderListButtoCardBRadius,
    fontSize: "12px",
    p: 5,
    fontWeight: 400,
  },

  profileViewPageBackColor: {
    boxShadow: "none",
    backgroundColor: "#e8f1f0",
    borderRadius: orderListButtoCardBRadius,
    fontSize: "12px",
    p: 5,
    fontWeight: 400,
  },
  profileViewPageBackColor23: {
    boxShadow: "none",
    backgroundColor: "#e8f1f0",
    borderRadius: orderListButtoCardBRadius,
    fontSize: "12px",
    p: 5,
    fontWeight: 400,
  },
  productCardTypograpy: {
    color: theme.palette.orderListProp.leftFontColor || "#85858f",
    fontWeight: 600,
    margin: 0,
    fontSize: "13px",
  },
  orderLsitHeadingTypo: {
    fontSize: orderListHeadingFontSize,
    fontWeight: 600,
    margin: 0,
    color: theme.palette.orderListProp.headingColor || "#639182",
  },
  orderLsitHeadingTypoColor: {
    color: theme.palette.orderListProp.headingColor || "#639182",
    fontWeight: 600,
  },
  changedBranchColor: {
    color: "orange",
    fontWeight: 600,
  },
  changedStatusColor: {
    color: "blue",
    fontWeight: 600,
  },

  orderLsitHeadingTypoView: {
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: "15px",
  },
  orTableHeaderRow: {
    textTransform: "uppercase",
    background: theme.palette.orderListProp.rightTopBgColor || "#ffffff",
    color: theme.palette.orderListProp.headingColor || "#639182",
    width: "100%",
  },
  orTableContainer: {
    width: "100%",
  },
  oLRightHeader: {
    borderColor: theme.palette.orderListProp.borderBgColor || "#e8f0f3",
    background: theme.palette.orderListProp.rightTopBgColor || "#ffffff",
  },
  oLTablHeader: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    color: theme.palette.orderListProp.payButtonColor || "#298076",
  },
  leftORTypo: {
    fontSize: "13px",
    color: theme.palette.orderListProp.leftFontColor,
  },
  rightORTypoColor: {
    color: theme.palette.orderListProp.rightFontColor,
  },
  rightORTypo: {
    fontSize: "13px",
    color: theme.palette.orderListProp.rightFontColor,
  },
  oLCardTitle: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    color: theme.palette.orderListProp.payButtonColor || "#c8f7a1",
    textTransform: "uppercase",
    // color: "#bdbec7",
  },
  orderListAddButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    backgroundColor: theme.palette.orderListProp.payButtonColor || "#c8f7a1",
    borderRadius: orderListButtonBRadius,
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
      backgroundColor: theme.palette.orderListProp.payButtonColor || "#c8f7a1",

      opacity: 0.65,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  orderListCancelButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    color: theme.palette.orderListProp.payButtonColor || "#c8f7a1",

    // backgroundColor: "#ff6c2f",
    borderRadius: orderListButtonBRadius,
    // boxShadow: "0px 2px 6px 0px",
    // color: '#aab8c5',
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
      // backgroundColor: theme.palette.orderListProp.payButtonColor || "#c8f7a1",

      // opacity: 0.65,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  oLQty: {
    width: "100%",
    backgroundColor: "white",
    // backgroundColor: theme.palette.cardAdd.secBackColor,
    borderRadius: orderListButtonBRadius,
    "& .MuiOutlinedInput-root": {
      borderRadius: orderListButtonBRadius,
      color: theme.palette.orderListProp.rightFontColor || "#85858f",
      backgroundColor: theme.palette.orderListProp.rightBgColor,
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
  },
  oLQtyIconButton: {
    width: 20,
    height: 20,
    backgroundColor: theme.palette.orderListProp.headingColor || "#c8f7a1",
    cursor: "pointer",
    borderRadius: orderListButtonBRadius,
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
      backgroundColor: theme.palette.orderListProp.payButtonColor || "#c8f7a1",
      opacity: 0.65,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  oLDeleteButton: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: 1.5,
    color: theme.palette.iconButton.deleteButtonColor,
    border: "none",
    padding: 1,
    minWidth: 44,
    height: 33,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.orderListProp.rightBgColor || "#ffffff",
    borderRadius: orderListButtoCardBRadius,
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.iconButton.deleteButtonColor,
      "& .MuiSvgIcon-root": {
        color: theme.palette.orderListProp.rightBgColor || "#ffffff",
      },
    },
    boxShadow: "none",
  },
  oLEditListIcon: {
    fontSize: "21px",
    color: theme.palette.iconButton.deleteButtonColor,
  },
  oLTextField: {
    flexGrow: 1,
    width: "100%",
    fontSize: "13px",
    color: theme.palette.orderListProp.leftFontColor,
  },
  oLConformButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: "uppercase",
    width: "100%",
    height: "45px",
    backgroundColor: theme.palette.orderListProp.payButtonColor || "#c8f7a1",
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
      backgroundColor: theme.palette.orderListProp.payButtonColor || "#c8f7a1",
      opacity: 0.5,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  oLOCancelButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: "uppercase",
    width: "100%",
    height: "45px",
    border: "1px solid",
    borderColor: theme.palette.orderListProp.payButtonColor || "#c8f7a1",
    color: theme.palette.orderListProp.payButtonColor || "#c8f7a1",
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
      color: theme.palette.orderListProp.payButtonColor || "#c8f7a1",
      opacity: 0.5,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },
  OLbody2: {
    fontSize: "0.875rem",
    lineHeight: 1.13,
    marginBottom: "1rem",
    fontWeight: 600,
    color: theme.palette.orderListProp.leftFontColor || "#85858f",
  },

  OLTypograpyNormal: {
    color: theme.palette.orderListProp.leftFontColor,
  },

  OLCardTitle256: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    color: theme.palette.orderListProp.leftFontColor,
  },

  OLRightCardTitle256: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    color: theme.palette.orderListProp.rightFontColor,
  },

  OLLeftHeading: {
    color: theme.palette.orderListProp.headingColor,
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: "15px",
  },
  editButtonListProfile: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: "8px",
    // opacity: 0.65,
    color: theme.palette.iconButton.editIconColor,
    border: "none",
    padding: 1,
    minWidth: 32,
    height: 25,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.iconButton.editButtonColor,
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.iconButton.editIconColor,
      "& .MuiSvgIcon-root": {
        color: theme.palette.iconButton.editButtonColor,
      },
    },
    boxShadow: "none",
  },
  editListIconProfileAddColor: {
    fontSize: "18px",
  },
  meetingLable1: {
    backgroundColor: theme.palette.cardAdd.thirdBgColor,
    borderRadius: setCardBRadius,
    p: "24px",
    boxShadow: "none",
    border: `2px solid ${theme.palette.cardAdd.thirdBgColor}`,
    // color: theme.palette.orderListProp.lable1FontColor,
  },
  addNewButton: {
    paddingX: "1rem",
    paddingY: "0.5rem",
    fontFamily: "inherit",
    textTransform: "none",
    fontWeight: 600,
    lineHeight: 1.5,
    backgroundColor: theme.palette.iconButton.addButtonColor,
    borderRadius: setBRadius,
    // boxShadow: "0px 2px 6px 0px",
    color: theme.palette.iconButton.addIconColor,

    // color: '#aab8c5',
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    "&:hover": {
      borderColor: "transparent",
      color: theme.palette.iconButton.addButtonColor,
      backgroundColor: theme.palette.iconButton.addIconColor,
    },
    "&:focus": {
      boxShadow: "0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5)",
    },
    "&:disabled": {
      opacity: 0.65,
    },
  },

  statusCreated: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#8a6d00",
    backgroundColor: "#fff9c4",
    width: 140,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  statusSent: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#e3791a",
    backgroundColor: "#fff1cd",
    width: 140,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  statusApproved: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#2e7d32",
    backgroundColor: "#d0f2d0",
    width: 140,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  statusProcessed: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#880e4f",
    backgroundColor: "#fce4ec",
    width: 140,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  statusConfirmed: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#6a1b9a",
    backgroundColor: "#f3e5f5",
    width: 140,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  statusUpdated: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#0277bd",
    backgroundColor: "#b3e5fc",
    width: 140,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  statusCompleted: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#1b5e20",
    backgroundColor: "#c8e6c9",
    width: 140,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  statusRejected: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#c62828",
    backgroundColor: "#ffcdd2",
    width: 140,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: setBRadius,
  },

  priceConfiremListCrd: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    // boxShadow: 1,
    border: `1px solid #d8dfe7`,
    borderRadius: 8,
    transition: "0.4s",
    "&:hover": {
      boxShadow: 1,
      transform: "scale(1.03)",
    },
  },
  iconLinkPropNormal: {
    cursor: "pointer",
    textDecoration: "none",
    color: "inherit",
  },
  editChipWorkTrue: {
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    fontSize: "14px",
    borderRadius: setBRadius,
    backgroundColor: "#cdffcd",
    color: "#007f00",
  },
  typobreack: {
    // fontWeight: 600,
    // fontSize: "12px",
    // color: "#007f00",
    fontSize: "15px",
    fontWeight: 500,
  },
  editChipWorkFalse: {
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    fontSize: "14px",
    borderRadius: setBRadius,
    backgroundColor: "#fff1cd",
    color: "#e3791a",
  },
  tablheader2: {
    borderBottom: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderTop: `1px solid ${theme.palette.cardAdd.borderColor}`,
    minWidth: "200px",
  },
  mL2Heading: {
    fontSize: "15px",
    fontWeight: 600,
    // color: theme.palette.orderListProp.lable2FontColor,
  },
  timeSchedule: {
    mb: 2,
    p: 2,
    border: `1px solid ${theme.palette.cardAdd.borderColor}`,
    borderRadius: setBRadius,
    backgroundColor: "#f9f9f969",
  },
  h4TextTopBar2: {
    fontSize: "15px",
    fontWeight: 600,
    // lineHeight: "21px",
    textTransform: "uppercase",
    color: "#c69b6b",
  },
  mobileListText: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
  },
  searchTextField23: {
    width: "100%",
    borderRadius: setBRadius,
    "& .MuiOutlinedInput-root": {
      borderRadius: setBRadius,
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
  },
  staffDhashboardSmallCard: {
    height: "100%",
    background: theme.palette.cardAdd.bgColor,
    boxShadow: "none",
    // color: theme.palette.primary.main,
    borderRadius: setCardBRadius,
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
  },
  staffDhashboardSmallCardWithoutBorder: {
    height: "100%",
    background: theme.palette.cardAdd.bgColor,
    boxShadow: "none",
    borderRadius: setCardBRadius,
  },
  h4QuotoTopBarSearch: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.topbarButton.topBarHeading,
  },
  staffHeadingDhashboardSmallCard: {
    height: "100%",
    background: theme.palette.cardAdd.bgColor,
    boxShadow: "none",
    // color: theme.palette.primary.main,
    borderRadius: setCardBRadius,
    // borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  oLFormiklHeader: {
    textTransform: "uppercase",
    color: theme.palette.orderListProp.leftFontColor,
    fontWeight: 600,
  },
  editFormikButton: {
    px: "1rem",
    py: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    borderRadius: setButtonBRadius,
    opacity: 0.65,
    color: "white",
    border: "none",
    padding: 1,
    minWidth: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.orderListProp.headingColor || "#639182",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.orderListProp.leftFontColor,
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    },
  },
  orderListFormikProductCard: {
    boxShadow: "none",
    backgroundColor:
      theme.palette.orderListProp.productCardBgColor || "#eaf3f2",
    borderRadius: orderListButtoCardBRadius,
    fontSize: "12px",
    p: 5,
    fontWeight: 400,
    cursor: "pointer",
    transition: "all 0.3s ease",

    "&:hover": {
      border: `5px solid ${theme.palette.orderListProp.headingColor}`,
      boxShadow: "0 0 8px rgba(0, 0, 0, 0.15)",
      borderRadius: orderListButtoCardBRadius,
    },
  },
}));
